import { CEAssessmentSummaryBase } from './ce-assessment-summary-base'


export class CEAssessmentSummary extends CEAssessmentSummaryBase {

}